module.exports = __webpack_public_path__ + "static/media/handClapping.d26bfaed.svg";